import { z } from 'zod';

import { ImportFormat } from '@/modules/api/codegen';
import type { MessageKey } from '@/modules/localizations/translations/types';

import { Delimiter } from '../types';

export const importFormSchema = z.object({
    secrets: z.custom<File>(val => val instanceof File, { message: 'form.error.required' as MessageKey }),
    format: z.nativeEnum(ImportFormat),
    delimiter: z.nativeEnum(Delimiter),
    replaceSecrets: z.boolean(),
    vaultId: z.string().optional(),
});

export type ImportFormSchemaType = typeof importFormSchema;

export type ImportFormValues = z.infer<typeof importFormSchema>;
